import React from 'react';
import PropTypes from 'prop-types';

import Style from './styles.module.css';

const Thumbnail = ({ src, renderIcon, onClick, index, imageObjectFit }) => (
  <div
    style={onClick ? { cursor: 'pointer' } : undefined}
    className={Style.thumbnail}
    onClick={() => onClick(index)}
    onKeyPress={() => onClick(index)}
  >
    <div className={Style.icon}>{renderIcon()}</div>
    <img src={src} alt="thumbnail" style={{ objectFit: imageObjectFit }} />
  </div>
);

const ThumbnailGallery = (props) => {
  const { images, renderIcon, onThumbnailClick, imageObjectFit } = props;

  return (
    <div className={Style.container}>
      {images.map((image, index) => (
        <Thumbnail
          // eslint-disable-next-line react/no-array-index-key
          key={`${image}-${index}`}
          src={image}
          renderIcon={renderIcon}
          index={index}
          onClick={onThumbnailClick}
          imageObjectFit={imageObjectFit}
        />
      ))}
    </div>
  );
};

ThumbnailGallery.propTypes = {
  // Array of image urls or encoded data strings.
  images: PropTypes.arrayOf(PropTypes.string),
  // Render function to display icons in top right corner of thumbnails.
  renderIcon: PropTypes.func,
  // Callback function for when a thumbnail is clicked. Passed a single integer arguement of
  // index of the thumbnail that was clicked.
  onThumbnailClick: PropTypes.func,
};

ThumbnailGallery.defaultProps = {
  images: [],
  renderIcon: () => {},
  onThumbnailClick: () => {},
};

export default ThumbnailGallery;
